import { AcquisitionChannel } from '@nemuru-eng/js-api-client';

import { EXCLUDED_IBERIA_MERCHANT_IDS } from '@/components/modules/PricingsList/components/Filters/components/LendersList/constants/constants';

// This function checks if the merchant ID is excluded from the Iberia lender constrained list
// and returns true if the merchant ID is not excluded, false otherwise

export const shouldApplyIberiaLenderWhitelist = (merchantId: string, acquisitionChannel: AcquisitionChannel): boolean =>
  acquisitionChannel === AcquisitionChannel.IBERIA && !EXCLUDED_IBERIA_MERCHANT_IDS.includes(merchantId);
